var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3093,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7087 20.6131V15.0595H10.8398V12.8952H12.7087V11.2991C12.7087 9.44678 13.84 8.43817 15.4924 8.43817C16.2839 8.43817 16.9642 8.4971 17.1624 8.52344V10.4592L16.0164 10.4597C15.1178 10.4597 14.9438 10.8867 14.9438 11.5134V12.8952H17.087L16.8079 15.0595H14.9438V20.6131H12.7087Z",
    fill: "#2C444E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.906e48f079f79f614e76e0964655b894.svg";
export { ForwardRef as ReactComponent };